import styled from 'styled-components';

const Required = styled.span`
  display: flex;
  justify-content: center;
  background-color: #dddddd;
  line-height: 10px;
  width: 51px;
  height: 18px;
  font-size: 10px;
  padding: 4px;
  border-radius: 4px;
  color: #797979;
  margin-left: 10px;
  text-align: center;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 10px;
  letter-spacing: -0.1px;
`;

export default Required;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Required/index.jsx